<template>
    <div class="window-wrapper window-mail-no-format">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Неверный формат файла, выберите другой файл в формате <strong>{{getTypesString}}</strong></div>
                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InvalidFileFormatWindow",
        props: ['types'],
        computed: {
            getTypesString() {
                let result = '';
                for (let i = 0; i < this.types.length; i++) {
                    result += this.types[i];
                    if (i !== this.types.length - 1) {
                        result += ', ';
                    }
                }
                return result;
            }
        },
        methods: {
            closeWindow() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>